import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Text from '../../form/form-text'
import Switch from '../../form/form-switch'

class ModuleMosaic extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }
        this.i18n = 'app.modules.components.'
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { gridButtonName, liveTimeslotTeaser, otherTimeslotTeaser, replayButtonName, title } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-tvGridMeta">
            <Text disabled={disabled} label={'app.title'} value={title} />
            <Text disabled={disabled} label={this.i18n + 'guests'} value={guests} />
            <Switch disabled={disabled} labelLeft={this.i18n + 'timeslot'} labelRight={this.i18n + 'manuel'} value={timeslot} />
            {/*<Text disabled={disabled} label={this.i18n + 'elements'} value={otherTimeslotTeaser} />*/}
        </div>;
    }
}

ModuleMosaic.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    title: PropTypes.string,
    guests: PropTypes.string,
    timeslot: PropTypes.bool,
    elements: PropTypes.array
}

export default ModuleMosaic;

